module.exports = __webpack_public_path__ + "img/poesia.10ceba1b.png";